import * as React from 'react';
import { styled } from '@mui/material/styles';
import { Translate } from '../../../../../../../shared/LanguageService';
import { ImageLoadingSkeleton } from '../../../shared/imageCard/view/ImageLoadingSkeleton';
import { ThumbnailArea, ThumbnailCardFrame } from './ThumbnailCardFrame';

const FilenameOverlay = styled('figcaption')({
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    color: '#e7e7e7',
    backgroundColor: 'rgba(0, 0, 0, 0.25)',
    padding: '4px 8px',
    fontSize: '16px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    zIndex: 2
});

type ImageInProgressCardProps = {
    filename: string | null;
};

export function ImageInProgressCard({ filename }: ImageInProgressCardProps) {
    let label = filename || Translate('order-page/edited-image/upload-in-progress');

    return (
        <ThumbnailCardFrame data-testid="image-in-progress-card">
            <ThumbnailArea role="img" aria-label={label} aria-busy="true">
                <ImageLoadingSkeleton />
                {filename && <FilenameOverlay>{filename}</FilenameOverlay>}
            </ThumbnailArea>
        </ThumbnailCardFrame>
    );
}
